var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeMagixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 127,
    viewBox: "0 0 79 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9998 0V63.6872C78.9998 46.8408 63.1953 42.6888 63.1953 26.0013C63.1953 15.6779 68.6009 6.13729 77.3614 0.96427L78.9998 0Z",
    fill: "url(#paint0_linear_436_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1955 26.0012V51.1743L31.6089 27.6802V74.5324C31.6089 77.1416 31.9879 79.4898 32.7012 81.6793L19.6943 72.0026C19.3042 71.7076 18.9475 71.4013 18.6132 71.061H18.602C5.72884 59.5011 5.17156 43.7551 15.8045 36.9599L14.1772 37.9241C5.39447 43.1085 0 52.6378 0 62.9611V63.3128C0 80.0117 15.7933 84.1637 15.7933 101.01V75.2924L47.3911 98.7866V51.9231C47.3911 49.3365 46.9898 46.9656 46.2654 44.7534L59.2946 54.4415C59.6735 54.7478 60.0302 55.0654 60.3869 55.3944C73.26 66.9543 73.8173 82.8818 63.1844 89.6771L64.7671 88.7468C73.5721 83.5738 78.9889 74.0219 78.9889 63.6872C78.9889 46.8408 63.1844 42.6888 63.1844 26.0012H63.1955Z",
    fill: "url(#paint1_linear_436_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5905 71.0496C5.71735 59.5011 5.16007 43.7551 15.793 36.9598V64.2203C15.793 66.8068 16.8184 69.2572 18.5905 71.0496Z",
    fill: "url(#paint2_radial_436_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3867 55.3944C73.2599 66.943 73.8172 82.8818 63.1843 89.677V62.4166C63.1843 59.83 62.1589 57.1868 60.3867 55.3944Z",
    fill: "url(#paint3_radial_436_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7933 101.01C15.6707 111.209 10.2762 120.59 1.58267 125.707L0 126.637V63.3129C0 80.0118 15.7933 84.1638 15.7933 101.01Z",
    fill: "url(#paint4_radial_436_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 127V63.3129C0 80.1592 15.8045 84.3113 15.8045 100.999C15.8045 111.322 10.3988 120.863 1.6384 126.036L0 127Z",
    fill: "url(#paint5_radial_436_336)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_436_336",
    x1: 78.866,
    y1: 31.7642,
    x2: 68.5498,
    y2: 38.8645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#55B383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#45A678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2B9264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_436_336",
    x1: 0,
    y1: 63.5056,
    x2: 79,
    y2: 63.5056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB888"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_436_336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.58 41.3029) rotate(82.0991) scale(20.617 12.5671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#57B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4BAB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#389C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288F62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_436_336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5952 85.5212) rotate(-97.9009) scale(20.7304 12.6363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#57B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4BAB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#389C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288F62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_436_336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.975133 109.517) rotate(-106.394) scale(31.0957 19.3022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CDD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#85C9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7CBDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6EAAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5A8FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#406C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5476"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_436_336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.21287 113.042) rotate(-105.586) scale(38.9513 20.7189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#57B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4BAB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#389C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288F62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 127,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeMagixLogo);
export default __webpack_public_path__ + "static/media/exchange_magix_logo.91eb5689e561139318cf8cdfcdf6c48a.svg";
export { ForwardRef as ReactComponent };